<template>
  <div class="multimedia__content-grid multimedia__content-grid-modal">
    <div v-for="(images, key) in imagesList"
         :key="key">
      <div class="multimedia__content-grid-label"> {{ key }}</div>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div class="cell small-12 medium-6 large-4"
             v-for="(img, index) in images"
             :key="`img-${index}`">
          <multimedia-image
            @selected="selectElement"
            :image="img"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MultimediaImage from '@/components/multimedia/items/Image.vue';
import { CAROUSEL_OPEN } from '@/eventTypes';
import EventBus from '@/eventBus';

export default {
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  components: {
    MultimediaImage,
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['getUserMultimedia']),
    imagesList() {
      return this.getMultimedia.multimedia ?? {};
    },
    getMultimedia() {
      return this.getUserMultimedia(this.clientId, 'image') ?? {};
    },
  },
  methods: {
    selectElement(image) {
      if (image.multimedia) {
        const payload = {
          url: `${image.multimedia.file}?token=${this.token}`,
          type: 'image',
        };

        EventBus.$emit(CAROUSEL_OPEN, payload);
      }
    },
  },
};
</script>
